import { ModelConverter as BaseModelConverter } from 'lib/domain/model/ModelConverter';
import { HttpPersistence } from 'lib/persistence/http/HttpPersistence';

import {
	SequenceModelConverter as ModelConverter,
	SequencePersistenceModel as PersistenceModel,
	SequenceStoreModel as StoreModel,
	SequenceViewModel as ViewModel,
	CreatableSequenceViewModel as CreatableViewModel
} from 'services/device/domain/model/SequenceModel';

export class SequenceHttpPersistence extends HttpPersistence<PersistenceModel, StoreModel, ViewModel, CreatableViewModel> {

	protected serviceApiControllerUri = 'device/api/v1';
	protected collectionControllerUri = 'sequences';
	protected entityControllerUri = 'sequence';

	protected responseCollectionKey = 'SequenceModelCollection';
	protected responseEntityKey = 'SequenceModel';

	protected modelConverter: BaseModelConverter<PersistenceModel, StoreModel, ViewModel, CreatableViewModel> = new ModelConverter();

}
